import { render } from "./activity-win.vue?vue&type=template&id=1bb3f88b"
import script from "./activity-win.vue?vue&type=script&lang=js"
export * from "./activity-win.vue?vue&type=script&lang=js"

import "./activity-win.vue?vue&type=style&index=0&id=1bb3f88b&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__